import React, { useState } from "react";
//import { Link } from "react-router-dom";
//import { Sliders } from "react-feather";
import {Modal, Progress, Select, Table} from "antd";
//import Swal from "sweetalert2";

import { getLateRecords } from "../../service/adminAttendanceService";
import okilogo from "../../assets/OKI-logo.png";
import jsPDF from "jspdf";
import dayjs from "dayjs";
import ExcelJS from "exceljs";
import { DatePicker } from "antd";
import { ArrowLeft } from "lucide-react";

const { RangePicker } = DatePicker;

const Report = () => {
  const startOfMonth = dayjs().startOf("month");
  const today = dayjs();
  const [dataSource, setDataSource] = useState([]);
  const [progress, setProgress] = useState(0);
  const [epf_number, setEpf] = useState("");
  const [name, setName] = useState("");
  const [branch, setBranch] = useState(null);
  const [center, setCenter] = useState(null);
  const [startDate, setStartDate] = useState(startOfMonth.format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(today.format("YYYY-MM-DD"));
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 })
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false)
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize)
  const pageSizeOptions = [5, 10, 20, 50, 100]

  const [loading, setLoading] = useState(false);
  const branchOptions = [
    { value: "wattala", label: "Wattala" },
    { value: "negombo", label: "Negombo" },
    { value: "kaduwela", label: "Kaduwela" },
    { value: "kiribathgoda", label: "Kiribathgoda" },
    { value: "kandana", label: "Kandana" },
    { value: "delgoda", label: "Delgoda" },
    { value: "lsu", label: "Wattala LSU" },
    { value: "cityschool", label: "City School - Negombo" }
  ];

  const centerOptions = [
    { value: "OKI", label: "OKI" },
    { value: "OKIDS", label: "OKIDS" },
    { value: "OKIT", label: "OKIT" },
  ];
  const onChange = (dates, dateStrings) => {
    setStartDate(dateStrings[0]);
    setEndDate(dateStrings[1]);
    console.log(startDate, endDate);
  };

  const lateRecords = async () => {
    try {
      setLoading(true);
      setProgress(1); // Start progress at 1%
      let currentProgress = 1;

      // Progress simulation
      const interval = setInterval(() => {
        if (currentProgress < 95) { // Prevent going to 100% before API response
          currentProgress += 1;
          setProgress(currentProgress);
        }
      }, 200); // Update every 50ms
      const response = await getLateRecords({
        epf_number,
        name,
        center,
        branch,
        startDate,
        endDate,
      });
      setDataSource(response.data);
      setLoading(false);
      clearInterval(interval); // Stop incrementing once response is received
      setProgress(100); // Set to 100% after API response
      setLoading(false);
      console.log(response.data, "resopons");
    } catch (error) {
      console.error("Error fetching leaves:", error);
    }
  };

  const handlePdfExport = async () => {
    // const startdate = startDate.format('YYYY-MM-DD');
    // const enddate = endDate.format('YYYY-MM-DD');
    const img = okilogo;

    // Filter out unwanted columns

    const doc = new jsPDF();
    doc.setTextColor(0, 0, 0); // Blue color
    doc.setFontSize(16);
    doc.text("OKI International", 15, 13);

    // Larger font size

    doc.setFontSize(14);
    doc.setTextColor(138, 132, 125);
    doc.text(`Late Attendance Report`, 15, 23);
    // doc.text(`Date : ${startDate} - ${endDate}`, 15, 30);
    doc.addImage(img, "PNG", 170, 8, 22, 25);
    doc.autoTable({
      head: [
        ["Emp Name", "EPF No", "Branch", "Center", "Total Late Time (HH:MM)"],
      ],

      body: dataSource.map(({ employee, totalLatetime }) => [
        [`${employee.first_name} ${employee.last_name}`],
        [employee.employee_id],
        [employee.branch],
        [employee.center],
        [totalLatetime],
      ]),
      startY: 35,
      theme: "striped",
      headStyles: {
        fillColor: [138, 132, 125],
      },
    });

    doc.save("late_attendance_report.pdf");
  };

  ///Excel export

  const handleExcelExport = () => {
    const workbook = new ExcelJS.Workbook();


    const worksheet = workbook.addWorksheet("Late Attendance Report");

    // Define cell styles with borders
    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    // Define columns and add header
    worksheet.columns = [
      { header: "Emp Name", key: "empName", width: 25 },
      { header: "EPF No", key: "empId", width: 15 },
      { header: "Branch", key: "branch", width: 15 },
      { header: "Center", key: "center", width: 15 },
      { header: "Late Time (HH:MM)", key: "lateTime", width: 20 },
    ];

    console.log("Data _______________",dataSource)
    // Add data rows
    dataSource.forEach(employee =>  {
      console.log("Employee _______________----",employee)
      worksheet.addRow({
        empName: employee.employeeName,
        empId: employee.epf,
        branch: employee.branch,
        center: employee.center,
        lateTime: employee.totalLatetime,
      });
    });

    // Apply border styles to all cells
    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = borderStyle;
      });
    });

    // Save the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "late_attendance_report.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    });

  };

  const columns = [
    {
      title: "Emp Name",
      dataIndex: "employeeName",
      key:"empName"
    },
    {
      title: "EPF No",
      dataIndex: "epf",
      key:"epf"
    },
    {
      title: "Branch",
      dataIndex: "branch"
    },
    {
      title: "Total Late Time (HH:MM)",
      dataIndex: "totalLatetime",
    },
  ];

  const handleTableChange = (pagination) => {
    setPagination(pagination)
  }

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 }
    setPagination(newPagination)
    setPageSizeModalVisible(false)
  }
  return (
    <div>
      <div className="page-wrapper-lt">
        <div className="content">
          {loading?
                <Progress percent={progress} size="small" />:""
          }

          <div className="page-header">
              <div className="add-item d-flex">
                   <div className="header-leave-container ">
                     <div>
                       <ArrowLeft size={32} />
                     </div>
       
                     <div className="page-title">
                       <h4>Late Attendance</h4>
                       <h6>Manage Employee late attendance </h6>
                     </div>
                   </div>
                   <div className="wordset">
              <ul>

                <li>
                  <a title="pdf" onClick={handlePdfExport}>
                    <img src="assets/img/icons/pdf.svg" alt="pdf" />
                  </a>
                </li>
                <li>
                  <a title="excel" onClick={handleExcelExport}>
                    <img src="assets/img/icons/excel.svg" alt="excel" />
                  </a>
                </li>
                {/* <li>
                        <a href="#" title="print">
                          <img src="assets/img/icons/printer.svg" alt="print" />
                        </a>
                      </li> */}
              </ul>
            </div>
            </div>
       
            {/* <div className="page-btn">
              <Link to="/allocate-leaves" className="btn btn-added">
                Allocated Leaves
              </Link>
            </div>
            <div className="page-btn">
              <Link to="/leave-types" className="btn btn-added">
                Leave types
              </Link>
            </div> */}
          </div>
          <div className="card table-list-card-grid">
            <div
              className="card-body"
              style={{ maxWidth: "100%", marginRight: "20px" }}
            >
              <div
                className="container mt-3 "
                style={{
                  maxWidth: "100%",
                  marginLeft: "20px",
                  marginRight: "40px",
                }}
              >
                {" "}
                {/* Added p-0 and maxWidth */}
                <div className="row d-flex flex-wrap align-items-start justify-content-between">
                  {" "}
                  {/* Added justify-content-start */}
                  <div className="col-12 col-md-3  text-start">
                    <label className="form-label">Employee Name</label>
                    <input
                      type="text"
                      value={name}
                      className="form-control"
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      style={{ width: "100%", height: "38px" }}
                    />
                  </div>
                  <div className="col-12 col-md-2 mb-3 text-start">
                    <label className="form-label">EPF No</label>
                    <input
                      className="form-control"
                      type="text"
                      value={epf_number}
                      onChange={(e) => setEpf(e.target.value)}
                      style={{ width: "100%", height: "38px" }}
                    />
                  </div>
                  <div className="col-12 col-md-2 mb-3 text-start">
                    <label className="form-label">Branch</label>

                    <Select
                      value={branch}
                      options={branchOptions}
                      className="select"
                      placeholder="Select Branch"
                      onChange={setBranch}
                      allowClear
                      style={{ width: "100%", height: "38px" }}
                    />
                  </div>
                  <div className="col-12 col-md-2 mb-3 text-start">
                    <label className="form-label">Center</label>

                    <Select
                      value={center}
                      options={centerOptions}
                      className="select"
                      placeholder="Select Center"
                      onChange={setCenter}
                      allowClear
                      style={{ width: "100%", height: "38px" }}
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-3 text-start">
                    <label className="form-label">Date</label>

                    <RangePicker
                      format="YYYY-MM-DD"
                      onChange={onChange}
                      //disabledDate={disabledDate}
                      defaultValue={[startOfMonth, today]}
                      style={{ width: "100%" }}
                      allowClear={false}
                    />
                  </div>
                </div>
              </div>

              <div
                className="container mt-0"
                style={{
                  maxWidth: "100%",
                  marginLeft: "20px",
                  marginRight: "40px",
                }}
              >
                <div className="row d-flex align-items-center justify-content-start">
                  <div className="col-12 col-md-2 mb-3 text-start">
                    <button
                                                                                    disabled={loading}

                      className="btn btn-submit"
                      onClick={lateRecords}
                      style={{ height: "38px", width: "55%" }}
                    >
                           {loading 
                            ? "Search "
                            : "Search"}
                    </button>
              
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card table-list-card-grid">
            <div className="card-body pb-0">
              <div className="table-top">
                <div className="input-blocks search-set mb-0"></div>
              </div>
            </div>
            <div className="table-responsive">
              <Table
                loading={loading}
                columns={columns}
                dataSource={dataSource}
                rowKey={(record) => record.id}
                className="custom-ant-table-grid"
                pagination={{
                  current: pagination.current,
                  total: dataSource.length,
                  pageSizeOptions: ["5", "10", "20", "50"],
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total) => `Total ${total} items`
                }}
                onChange={handleTableChange}
                // footer={() => (
                //   <div style={{ display: "flex", justifyContent: "flex-end" }}>
                //     <button className="btn btn-primary btn-sm" onClick={() => setPageSizeModalVisible(true)}>
                //       Change Page Size
                //     </button>
                //   </div>
                // )}
              />
            </div>
          </div>
        </div>
      </div>
            <Modal
              title="Change Page Size"
              open={pageSizeModalVisible}
              onOk={handlePageSizeChange}
              onCancel={() => setPageSizeModalVisible(false)}
              footer={[
                <button key="cancel" className="btn btn-cancel" onClick={() => setPageSizeModalVisible(false)}>
                  Cancel
                </button>,
                <button key="submit" className="btn btn-submit" onClick={handlePageSizeChange}>
                  Apply
                </button>,
              ]}
            >
              <div className="form-group">
                <label>Items per page:</label>
                <Select style={{ width: "100%" }} value={tempPageSize} onChange={(value) => setTempPageSize(value)}>
                  {pageSizeOptions.map((size) => (
                    <Select.Option key={size} value={size}>
                      {size}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </Modal>
    </div>
  );
};

export default Report;
